<template>
    <div class="comment">
        <div class="comment-item">
            <Avatar :user="item.user" class="avatar-container">
                <img :src="item.user.avatar.url" alt="" class="avatar">
            </Avatar>
            <div class="comment-info">
                <div class="name-line">
                    <div class="username">{{ item.user.nickname }}</div>
                    <div class="date">
                        {{ dayjs(item.created_at).format('YYYY-MM-DD HH:mm') }}
                    </div>
                </div>
                <div class="content-container">
                    <div class="content-box">
                        <div class="content">{{ item.content }}</div>
                        <div class="action-box">
                            <Link class="action" @click="showReply">回复</Link>
                            <Link v-if="item.user.id === usePage().props?.auth?.user?.id" class="action grey"
                                  @click="onDeleteClick">删除
                            </Link>
                            <Link v-if="item.replies_for_pagination.data?.length" class="action"
                                  @click="replyShow = !replyShow">
                                {{ replyShow ? '收起' : '展开' }}
                            </Link>
                        </div>
                    </div>
                    <Like :is-like="item.like_status"
                          :like-url="route('api.work.comment.like',{comment:item.id})"
                          class="like-box">
                        <template #liked>
                            <div class="like active">
                                <i class="pt-icons-pickup"></i><span>{{
                                    item.likes_count + 1
                                }}</span>
                            </div>
                        </template>
                        <template #unLiked>
                            <div class="like">
                                <i class="pt-icons-pickup"></i><span>{{
                                    item.likes_count
                                }}</span>
                            </div>
                        </template>
                    </Like>
                </div>
            </div>
        </div>
        <div class="reply-box">
            <WorkCommentReplyList :list="item.replies_for_pagination"
                                  ref="replyList"
                                  :show="replyShow"
                                  :work-id="item.work_id"
                                  :comment-id="item.id"></WorkCommentReplyList>
        </div>

    </div>

</template>

<script setup lang="ts">

import {route} from "@/utils/common";
import dayjs from "dayjs";
import WorkCommentReplyList from "@/Components/WorkCommentReplyList.vue";
import Like from "@/Components/Like.vue";
import Avatar from "@/Components/Avatar.vue";
import {ref} from "vue";
import Link from "@/Components/Link.vue";
import {usePage} from "@inertiajs/vue3";

const props = defineProps<{
    item: object,
}>()

const emits = defineEmits(['delete'])

const replyList = ref()
const replyShow = ref(true)

const showReply = () => {
    replyList.value.showReply()
}

const onDeleteClick = () => {
    emits('delete')
}
</script>

<style scoped lang="less">
.comment {
    margin-bottom: 30px;

    .comment-item {
        display: flex;

        .avatar-container {
            width: 46px;
            height: 46px;
            flex-shrink: 0;

            .avatar {
                border-radius: 50%;
            }
        }

        .comment-info {
            margin-left: 20px;
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .name-line {
                display: flex;
                align-items: flex-end;

                .username {
                    color: #000000;
                    font-size: 14px;
                }

                .date {
                    color: #989898;
                    font-size: 12px;
                    margin-left: 10px;
                }
            }

            .content-container {
                margin-top: 8px;
                flex: 1;
                display: flex;
                justify-content: space-between;
                align-items: center;
                font-size: 14px;

                .content-box {
                    display: flex;
                    color: #666666;
                    align-items: center;

                    .action-box {
                        display: flex;
                        margin-left: 10px;
                        align-items: center;

                        .action {
                            padding: 8px;
                            font-size: 12px;
                            margin-right: 8px;

                            &.grey {
                                background: #F3F5F7;
                            }
                        }
                    }
                }

                .like-box {
                    .like {
                        display: flex;
                        align-items: center;
                        font-size: 14px;
                        color: #666666;

                        i {
                            color: #cccccc;
                            margin-right: 10px;
                        }

                        &.active {
                            i {
                                color: #FE2444;
                            }
                        }
                    }
                }
            }
        }
    }
}

</style>
